/* eslint-disable multiline-comment-style */
const log = require("../shared_utils/log.js");
const {
  fetchArrayBuffer,
  fetchJson,
  projectPath,
} = require("./utils/fetch-and-parse.js");
const {
  loadProjectFromZip,
  loadSceneFromSb3,
} = require("./utils/import-export-helpers.js");
const friendlyWords = require("friendly-words");

function fetchProject(projectId) {
  const project = { id: projectId };
  const baseFolder = "projects";
  const projectFolder = projectId;
  const url = `/provision/${baseFolder}/${projectFolder}/${projectId}.json`;

  return fetchJson(url).then((metadata) => {
    project.metadata = metadata;
    if (metadata.tutorial_scripts) {
      let tutorialPromises = metadata.tutorial_scripts.map((script) => {
        return fetchJson(`/provision/${baseFolder}/${projectFolder}/${script}`);
      });
      return Promise.all(tutorialPromises).then((tutorials) => {
        metadata.tutorials = tutorials;
        metadata.currentTutorial = tutorials[0];
        metadata.currentTutorialStep = metadata.currentTutorial.startingStepId;
        metadata.toolbar =
          metadata.currentTutorial[metadata.currentTutorialStep].toolbar;
        return metadata;
      });
    } else {
      if (metadata.project_file) {
        return Promise.resolve(metadata);
      }
      const fetchScenePromises = metadata.scenes.map((scene) =>
        fetchScene(scene, projectId)
      );
      return Promise.all(fetchScenePromises).then((results) => {
        project.scenes = results.filter(
          (r) => r.sb3 && (r.metadata || r.snapshot)
        );
        return project;
      });
    }
  });
}
function fetchScene(sceneDescription, projectId) {
  let metadataPromise = null;
  let sb3Promise = null;
  let snapshotPromise = null;
  const fetchPromises = [];
  if (sceneDescription.sb3) {
    const sb3Url = `${projectPath(projectId)}/${sceneDescription.sb3}`;
    sb3Promise = fetchArrayBuffer(sb3Url);
    fetchPromises.push(sb3Promise);
  } else {
    fetchPromises.push(Promise.resolve(null));
  }
  if (sceneDescription.metadata) {
    const metadataUrl = `${projectPath(projectId)}/${
      sceneDescription.metadata
    }`;
    metadataPromise = fetchJson(metadataUrl);
    fetchPromises.push(metadataPromise);
  } else {
    fetchPromises.push(Promise.resolve(null));
  }
  if (sceneDescription.snapshot) {
    const snapshotUrl = `${projectPath(projectId)}/${
      sceneDescription.snapshot
    }`;
    snapshotPromise = fetchJson(snapshotUrl);
    fetchPromises.push(snapshotPromise);
  } else {
    fetchPromises.push(Promise.resolve(null));
  }
  return Promise.all(fetchPromises).then((results) => ({
    sb3: results[0],
    metadata: results[1],
    snapshot: results[2],
    id: sceneDescription.id,
  }));
}

module.exports = function fetchAndLoadProject(state, emitter) {
  emitter.on("fetch-project", (projectId) => {
    log("fetch-project", projectId);
    state.currentTutorialStep = 0;
    const titleUpcase = projectId.toUpperCase();
    const pageTitle = `${titleUpcase} - FABLES AND FUTURES`;
    document.title = pageTitle;

    if (state.availableProjects.find((p) => p.id === projectId)) {
      fetchProject(projectId).then((project) => {
        state.projectMetadata = project.metadata;
        if (project.currentTutorial && state.playingTutorial) {
          state.currentTutorial = project.currentTutorial;
          state.currentTutorialStep = project.currentTutorialStep;
        }
        let exposedVariables = [];
        if (project.exposedVariables) {
          exposedVariables = project.exposedVariables;
        }
        state.projectMetadata = project;
        if (project.project_file) {
          const baseFolder = "projects";
          const projectFolder = projectId;
          const url = `/provision/${baseFolder}/${projectFolder}/${project.project_file}`;
          fetchArrayBuffer(url).then((results) => {
            loadProjectFromZip(results).then((zipProject) => {
              state.project = {};
              state.project.scenes = zipProject.scenes;

              state.project.scenes.forEach((scene) => {
                state.histories[scene.metadata.id] = [];
              });
              if (state.projectMetadata.id === "blank project") {
                const newId =
                  friendlyWords.predicates[
                    Math.floor(Math.random() * friendlyWords.predicates.length)
                  ] +
                  "-" +
                  friendlyWords.objects[
                    Math.floor(Math.random() * friendlyWords.objects.length)
                  ];
                state.projectMetadata.title = newId;
                state.projectMetadata.id = newId;
              }
              emitter.emit("render");
            });
            if (state.playingTutorial) {
              state.toolbar =
                state.currentTutorial[state.currentTutorialStep].toolbar;
            }
            return Promise.resolve(true);
          });
        }
      });
    }
  });
};
